import {
  AcknowledgeReply,
} from '@dapi/sdk';

export const acknowledgeSuccess: AcknowledgeReply = {};
